/**
 * !!!! You missed some "case" in the "switch" statement !!!
 * @example
 * type A = 'a' | 'b' | 'c';
 *
 * const test = (value: A) => {
 *   switch (value) {
 *     case 'a': return 'a';
 *     case 'b': return 'b';
 *   }
 *
 *   // we missed "case 'c'" - TypeScript error
 *   assertSwitchValueNotEmpty(value);
 * }
 */
export const assertSwitchValueNotEmpty = (value: never): never => value;

export const promiseTimer = <T>(delay: number, value?: T) =>
  new Promise<T>((resolve) => setTimeout(resolve, delay, value));
